import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { flatten, deepen } from '../../versa/record.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/carriers.js';
import form from '../forms/carriers.js';
import * as types from '../types.js';

const carriers = function()
{

	let carriers_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_cities, this.queryAll()).then((data) => db.set('cities', data).catch(error => notify(error)));
			api.call(api.list_carriers, this.queryAll()).then((data) => data && db.set('carriers', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_carriers, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_carrier, ...JSON.parse(id));
			_record = flatten(_record, 'address');
			if (_record.address_city_id) {
				const c = await db.get('cities', _record.address_city_id);
				if (c) {
					_record['address_state'] = c.state;
					_record['address_city_id'] = c.city;
				}
			}
			return _record;
		},
		async saveRecord(data, old_data)
		{
			const sel = '#carrier';
			const normalize = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
			const resolveCityId = async (state, cityVal) => {
				if (!state || cityVal == null || cityVal === '') return cityVal;
				const v = String(cityVal).trim();
				if (/^\d{7}$/.test(v)) return v;
				const range = IDBKeyRange.bound([state, ''], [state, '\uffff']);
				const cities = await db.list('cities', range, 2).catch(() => []);
				const c = (cities || []).find(x => normalize(x?.city || '') === normalize(v));
				return c ? c.id : cityVal;
			};
			const getAddr = (suffix) => {
				const el = document.querySelector(`${sel} #address_${suffix}`);
				return el?.value != null ? String(el.value).trim() : '';
			};
			const getField = (id) => {
				const el = document.querySelector(`${sel} #${id}`);
				return el?.value != null ? String(el.value).trim() : '';
			};
			const getZipFromDom = () => (getAddr('zipcode').replace(/\D/g, ''));
			// Garante valores do formulário: se data vier vazio, lê do DOM (formset às vezes não serializa todos os campos)
			const street = (data.address_street || getAddr('street')).trim();
			const number = (data.address_number || getAddr('number')).trim();
			const complement = (data.address_complement || getAddr('complement')).trim() || null;
			const district = (data.address_district || getAddr('district')).trim();
			const zipcode = (data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '')) || getZipFromDom();
			const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
			let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
			if (state && cityId)
				cityId = await resolveCityId(state, cityId);
			// Checkbox: preferir estado do DOM (evita valor antigo no storage ao desmarcar ao trocar para PJ)
			const chkNode = document.querySelector(`${sel} #is_local_delivery`);
			const isLocal = chkNode ? !!chkNode.checked : !!data.is_local_delivery;
			// API espera type como um char (J,F,G,L) e ie_type como char (1,2,9)
			const typeNorm = (t) => { const m = { 'PJ':'J','PF':'F','G':'G','L':'L','LOCAL':'L' }; return m[t] || t; };
			const ieTypeNorm = (v) => { const m = { 'Contribuinte':'1','Isento':'2','Não Contribuinte':'9','Nao Contribuinte':'9' }; return m[v] || (/^[129]$/.test(v) ? v : v); };
			let _record = {
				type: isLocal ? 'L' : typeNorm(data.type),
				nick: data.nick,
				name: data.name,
				cpf: isLocal ? null : (data.cpf || getField('cpf') || null),
				cnpj: isLocal ? null : (data.cnpj || getField('cnpj') || null),
				protheus_carrier_code: (data.protheus_carrier_code != null && String(data.protheus_carrier_code).trim() !== '')
					? String(data.protheus_carrier_code).trim()
					: (getField('protheus_carrier_code') || null),
				ie: isLocal ? null : data.ie,
				ie_type: isLocal ? null : ieTypeNorm(data.ie_type),
				phone: data.phone,
				email: data.email,
				is_local_delivery: isLocal,
			};
			if (data.address_id || street || number || district || zipcode || cityId) {
				_record['address'] = {
					id: data.address_id ? Number(data.address_id) : null,
					street: street || null,
					number: number || null,
					complement: complement,
					district: district || null,
					zipcode: zipcode || null,
					city_id: cityId || null
				};
			}
			if (old_data)
				return await api.call(api.update_carrier, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_carrier, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Transportador', types: [types.datalist()], placeholder: '', title: 'Apelido ou nome — selecione na lista, ou use Contém para buscar pelo texto', store: 'carriers', labels: ['nick', 'name'] },
		{ index: 3, field: 'type', label: 'Tipo', types: [types.opt_person_type()], placeholder: '', title: 'Tipo de personalidade jurídica' },
		{ index: 4, field: 'nick', label: 'Apelido', types: [types.datalist()], placeholder: '', title: 'Nome curto do transportador' },
		{ index: 5, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome ou razão social' },
		{ index: 6, field: 'cpf', label: 'CPF', types: [types.cpf()], placeholder: '000.000.000-00', title: 'Número do CPF' },
		{ index: 7, field: 'cnpj', label: 'CNPJ', types: [types.cnpj()], placeholder: '00.000.000/0000-00', title: 'Número do CNPJ' },
		{ index: 8, field: 'ie', label: 'IE', types: [types.ie()], placeholder: '000.000.000', title: 'Inscrição Estadual' },
		{ index: 9, field: 'ie_type', label: 'Tipo IE', types: [types.opt_ie_type(), types.datalist()], placeholder: '', title: 'Tipo de Inscrição Estadual' },
		{ index: 10, field: 'phone', label: 'Fone', types: [types.phone()], placeholder: '+00 (00) 0000-0000', title: 'Telefone' },
		{ index: 11, field: 'email', label: 'Email', types: [types.email()], placeholder: 'abc@xyz.com', title: 'Email' },
		{ index: 12, field: 'protheus_carrier_code', label: 'Cód. ERP', types: [], placeholder: '', title: 'Código da transportadora no ERP' },
	];

	carriers_crud.run(
		'carriers',
		'Transportadores',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default carriers;

